import { unleashClient } from '../../../unleash/Unleash';
import { calendlyLinks, calendlyLinkVariantSchema } from './calendlyLinks';
import { FeatureFlagSlug } from './discoveryCallsList';

const delimiter = '__';

export const discoveryCallsPrefix = 'discovery-call';

export const useDiscoveryCallsFlag = (featureFlagSlug: FeatureFlagSlug) => {
  const flag = unleashClient
    .getAllToggles()
    .find(
      t =>
        t.name.split(delimiter)[0] ===
        `${discoveryCallsPrefix}-${featureFlagSlug}`
    );

  const calendlyLinkKeyParsed = calendlyLinkVariantSchema.safeParse(
    flag?.name.split(delimiter)[1]
  );
  const calendlyLink = calendlyLinkKeyParsed.success
    ? calendlyLinks[calendlyLinkKeyParsed.data]
    : undefined;

  return flag
    ? { name: flag.name, enabled: true, calendlyLink: calendlyLink ?? null }
    : null;
};
